// src/components/mask/CnpjInput.tsx
import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface CnpjInputProps extends Omit<TextFieldProps, 'onChange'> {
    value: string;
    onChange: (value: string) => void;
    label?: string;
}

const CnpjInput: React.FC<CnpjInputProps> = ({
    value,
    onChange,
    label = 'CNPJ',
    ...props
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // só números, máximo 14 dígitos
        const digits = e.target.value.replace(/\D/g, '').slice(0, 14);

        // formata como 00.000.000/0000-00
        const formatted = digits.replace(
            /^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2}).*$/,
            (_m, g1, g2, g3, g4, g5) =>
                (g1 || '') +
                (g2 ? `.${g2}` : '') +
                (g3 ? `.${g3}` : '') +
                (g4 ? `/${g4}` : '') +
                (g5 ? `-${g5}` : '')
        );

        onChange(formatted);
    };

    return (
        <TextField
            {...props}
            label={label}
            value={value}
            onChange={handleChange}
            inputProps={{ maxLength: 18 }} // CNPJ formatado tem até 18 chars: 00.000.000/0000-00
            fullWidth
        />
    );
};

export default CnpjInput;

